import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const CheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const DiscountFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const AmountRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  > * {
    flex: 1;
    min-width: 0;
  }
`
